<template>
	<div class="content" @scroll='onScroll'>
		<div class='wallpaper'>
			<div class='backpaper' :style='styleObj'></div>
			<h1 class="title">
				<slot name='title'></slot>
				<p class='title-line'></p>
			</h1>
			<div class='map-box'>
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    backImg: ''
  },
  computed: {
    styleObj () {
      const commonStyle = {
        background: `url(${this.backImg}) no-repeat center top`,
        backgroundSize: '100%'
      }
      return commonStyle
    }
  },
  methods: {
    onScroll () {
      console.log()
    }
  }
}
</script>

<style lang='scss' scoped>
	@import '../assets/style/veriable.scss';
	.content {
		width: 100%;
		height: 100%;
		overflow-y: auto;
		background-color: #fff;
	}
	.wallpaper {
		width: 100%;
		min-width: 1088px;
		background-color: #fff;
		position: relative;
		/*height: 735px;*/
		.title {
			position: relative;
			font-size: 48px;
			color: #FFFFFF;
			letter-spacing: 0;
			line-height: 48px;
			font-weight: 500;
			padding: 129px 0 89px;
			.title-line {
				width: 68px;
				height: 2px;
				background-color: #F13A30;
				margin: 50px auto 0;
			}
		}
		.backpaper {
			height: 550px;
			position: absolute;
			top: 0;
			width: 100%;
		}
		.map-box {
			position: relative;
			width: 75.5%;
			min-width: $mapBoxWidth;
			margin: 0 auto 100px;
			background: #FFFFFF;
			border: 1px solid transparent;
			border-radius: 6px;
			box-shadow: 0 2px 5px 0 rgba(0,0,0,0.05);
			background-color: #fff;
		}
	}
</style>



// WEBPACK FOOTER //
// wall.vue?8e674072